import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';

interface Props {
  title?: string;
  children?: React.ReactNode;
  wrapClassNm?: string;
  contClassNm?: string;
}

export default function ModalLayout({
  title,
  children,
  wrapClassNm,
  contClassNm
}: Props) {
  return <div className={`pop_wrap${wrapClassNm ? ` ${wrapClassNm}` : ''}`}>
      <div className="modal_header">
          <div className="title">{title}</div>
      </div>
      <div className={`pop_contents${contClassNm ? ` ${contClassNm}` : ''}`}>
        {children}
      </div>
      <Dialog.Close className="btn-x btn-x-white">
        <span className="sr-only">팝업 닫기</span>
      </Dialog.Close>
  </div>
}